import { useContext } from "react";

import { TileLayer } from "react-leaflet";
import WrfContext from "../contexts/WrfContext";
import { toApiTimeFormat } from "../shared/tileOverlay";

export interface WrfLayerProps {
  opacity: number;
}

// Pure render: "frames loaded" is tracked in WrfContext (driven by the data),
// not here, so it stays in sync even while this layer is unmounted (hidden).
const WrfLayer = ({ opacity }: WrfLayerProps) => {
  const wrf = useContext(WrfContext);

  if (wrf?.activeApiResponse) {
    const { frame, product } = wrf;
    const { baseURL, nullTile, times } = wrf.activeApiResponse;
    const layers = times.map((time, i) => (
      <TileLayer
        zIndex={100}
        // Key on product + time so switching products remounts cleanly even if
        // rainfall and wind share a timestamp (avoids stale in-place tiles).
        key={product + ":" + time.toISOString()}
        errorTileUrl={nullTile}
        url={baseURL + "/" + toApiTimeFormat(time) + "/{z}/{x}/{y}.png"}
        opacity={frame === i ? opacity : 0}
      />
    ));
    return <>{layers}</>;
  } else {
    return <></>;
  }
};

export default WrfLayer;
